import { NextPageContext } from "next";
import dynamic from "next/dynamic";
import globalGetServerSideProps from "../services/queries/utils/globalGetServerSideProps";

const MainPage = dynamic(() => import("../common/MainPage"), {
	ssr: false,
});

const Error = dynamic(() => import("./_error.page"), {
	ssr: false,
});

interface iProps {
	data: any;
	menuData: any;
}

const Page = (props: iProps) => {
	const { data } = props;

	return <>{data ? <MainPage {...props} /> : <Error {...props} />}</>;
};

export async function getServerSideProps(context: NextPageContext) {
	try {
		const globalProps = await globalGetServerSideProps(context, true);

		// If no locale was found, set the response to 404
		if (globalProps.props?.notLocaleFound) {
			if (context?.res) {
				context.res.statusCode = 404;
			}
		}

		if (globalProps?.props?.statusCode === undefined) {
			globalProps.props.statusCode = null;
		}

		return globalProps;
	} catch (error) {
		console.log("error", error);
		return {
			// redirect: {
			// 	permanent: false,
			// 	destination: "/en",
			// },
			props: {},
		};
	}
}

export default Page;
